import CardExtraResources from "./CardExtraResources";
import CardUpdatedHours from "./CardUpdatedHours";
import CardExtraTime from "./CardExtraTime";

const CardAdmin = ({ activeModalDetailsProject, projectDetails, auth, deleteRow = () => { } }) => {

    if (auth.isUser) return <></>;

    return (
        <>
            <div className="order-5 col-span-full">
                <CardExtraResources
                    isAdmin={auth.isAdmin}
                    isSuperAdmin={auth.isSuperAdmin}
                    extraResources={projectDetails.extraResources}
                    deleteRow={deleteRow}
                    activeModalDetailsProject={activeModalDetailsProject}
                />
            </div>

            <div className="order-5 col-span-full">
                <CardUpdatedHours
                    backups={projectDetails.backups}
                    isAdmin={auth.isAdmin}
                    isSuperAdmin={auth.isSuperAdmin}
                    deleteRow={deleteRow}
                    activeModalDetailsProject={activeModalDetailsProject}
                />
            </div>
            <div className="order-5 col-span-full">
                <CardExtraTime
                    isAdmin={auth.isAdmin}
                    isSuperAdmin={auth.isSuperAdmin}
                    extraTime={projectDetails.extraTime}
                    deleteRow={deleteRow}
                    activeModalDetailsProject={activeModalDetailsProject}
                />
            </div>
        </>
    );
};

export default CardAdmin;
